import { useState } from 'react';

const faqs = [
  {
    q: 'Precisa ter experiência com PNL para começar?',
    a: 'Não. Os exercícios são criados para iniciantes absolutas. Você começa pelos gratuitos, sem nenhum conhecimento prévio, e já vai sentir a diferença na primeira prática.',
  },
  {
    q: 'Quanto tempo leva para ver resultados?',
    a: '92% das nossas alunas relatam mudanças perceptíveis nos primeiros 21 dias de prática. Algumas técnicas, como a Ancoragem Emocional, geram impacto já na primeira sessão.',
  },
  {
    q: 'Os exercícios gratuitos são de qualidade ou são só "amostra"?',
    a: 'São técnicas completas de PNL Clínica — as mesmas usadas em consultório. O acesso pago adiciona áudios guiados, workbooks e suporte, mas os exercícios em si são 100% funcionais.',
  },
  {
    q: 'E se eu não me adaptar ao método?',
    a: 'O plano completo tem garantia incondicional de 7 dias. Se por qualquer motivo não for para você, devolvemos 100% do valor sem perguntas. Sem burocracia.',
  },
  {
    q: 'Funciona para qualquer área da vida?',
    a: 'Sim. Temos exercícios específicos para carreira, finanças, relacionamentos, saúde e autoconhecimento. O diagnóstico gratuito identifica por onde começar no seu caso.',
  },
];

export default function IGFAQ() {
  const [aberto, setAberto] = useState<number | null>(null);

  return (
    <section className="py-20 px-5 bg-luxury-black">
      <div className="max-w-lg mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="font-display text-3xl font-bold text-white leading-tight mb-3">
            Dúvidas frequentes
          </h2>
          <p className="text-white/40 text-sm">Tudo que você precisa saber antes de começar</p>
        </div>

        {/* Accordion */}
        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
                aberto === i
                  ? 'border-gold-500/30 bg-gradient-to-br from-gold-500/[0.07] to-transparent'
                  : 'border-white/[0.07] bg-white/[0.02] hover:border-white/15'
              }`}
            >
              <button
                onClick={() => setAberto(aberto === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 cursor-pointer text-left"
              >
                <span className={`text-sm font-semibold leading-snug pr-3 transition-colors ${
                  aberto === i ? 'text-gold-300' : 'text-white/75'
                }`}>
                  {faq.q}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full shrink-0 transition-all ${
                  aberto === i ? 'bg-gold-500/20 rotate-180' : 'bg-white/[0.06]'
                }`}>
                  <i className={`ri-arrow-down-s-line text-sm ${aberto === i ? 'text-gold-400' : 'text-white/30'}`} />
                </div>
              </button>

              {aberto === i && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-white/50 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
